import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteConfig } from "@/mocks/comics";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "恋爱甜漫", path: "/category/romance" },
  { name: "热血动作", path: "/category/action" },
  { name: "奇幻冒险", path: "/category/fantasy" },
  { name: "悬疑惊悚", path: "/category/thriller" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold font-heading"
          >
            <span
              className={`transition-colors duration-300 ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              韩漫屋
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled
                      ? "text-primary-500"
                      : "text-primary-300"
                    : scrolled
                    ? "text-foreground-600 hover:text-foreground-950"
                    : "text-background-50/80 hover:text-background-50"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${
                scrolled
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-accent-400 text-foreground-950 hover:bg-accent-300"
              }`}
            >
              联系我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-5 py-2.5 rounded-full text-sm font-semibold text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}